import { DeclarantDetails } from './DeclarantDetails';
import { Text } from '@nike/eds';
import GraphQLService from '../../shared/GraphQLService';
import useSWR from 'swr';
import  { Declarant } from './DeclarantDetails';

const api = new GraphQLService();

const useDeclarantsApi = () => {
    const fetcher = async () => await api.getDeclarants();
    return useSWR("getDeclarants", fetcher, { refreshInterval: 360000 });
}

export function Declarants()    {
    const { data, isLoading, error } = useDeclarantsApi();

    return (
        <div  className="eds-spacing--mb-24">
            <Text 
              className="eds-spacing--mb-8"
              font={'title-3'} 
              as={'h2'}>Declarants</Text>
            {isLoading && <Text>Loading declarants...</Text>}
            {error && <div style={{ color: 'red' }}>Error: {error.message}</div>}
            <div className="eds-flex eds-gap--16 ">
                {(data?.data?.getDeclarants?.items || []).map((declarant: Declarant, index: number) => (
                    <DeclarantDetails key={index} declarant={declarant} />
                ))}
            </div>
        </div>
    );
}